import { ReactNode } from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";

export const PrintPanelTemplate = (props: { children: ReactNode }) => {
  return (
    <SCol sm={5}>
      <SRootDiv className="p-3">{props.children}</SRootDiv>
    </SCol>
  );
};

const SRootDiv = styled.div`
  box-shadow: 1px 1px 3px #888;
`;

const SCol = styled(Col)`
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
